export default "__VITE_ASSET__CQp70dXw__"